import axios from "axios";

const modulePurchaseRequest = {
  namespaced: true,
  state: {
    purchaseRequests: [],
    filter: "",
  },
  mutations: {
    setPurchaseRequests(state, data) {
      state.purchaseRequests = data;
    },
    setFilter(state, value) {
      state.filter = value;
    },
  },
  actions: {
    async fetchPurchaseRequests({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(`/api/pr/${clinicUrl}/${branchUrl}`);
        const items = res.data.data;
        commit("setPurchaseRequests", items);
        return items;
      } catch (err) {
        console.error("fetchPurchaseRequests failed", err);
        throw err;
      }
    },
    async fetchPrById(_, { clinicUrl, branchUrl, id }) {
      try {
        const res = await axios.get(`/api/pr/${clinicUrl}/${branchUrl}/${id}`);
        return res.data.data;
      } catch (err) {
        console.error("fetchPrById failed", err);
        throw err;
      }
    },
    async createPurchaseReuqest(_, { clinicUrl, branchUrl, mrpId, lines }) {
      try {
        const payload = { lines };
        if (mrpId) {
          payload.mrpId = mrpId;
        }
        const res = await axios.post(`/api/pr/${clinicUrl}/${branchUrl}`, payload);
        return res.data.data;
      } catch (err) {
        console.error("createPr failed", err);
        throw err;
      }
    },
    async updatePurchaseRequest(_, { clinicUrl, branchUrl, prId, lines }) {
      try {
        const res = await axios.put(`/api/pr/${clinicUrl}/${branchUrl}/${prId}`, {
          lines,
        });
        return res.data.data;
      } catch (err) {
        console.error("updatePr failed", err);
        throw err;
      }
    },
    async approvePurchaseRequest(_, { clinicUrl, branchUrl, prId }) {
      try {
        const res = await axios.post(
          `/api/pr/${clinicUrl}/${branchUrl}/${prId}`,
          { status: "APPROVED" },
          { skipGlobalErrorHandler: true }
        );
        return res.data.data;
      } catch (err) {
        console.error("approvePr failed", err);
        throw err;
      }
    },
  },
  getters: {
    getPrList: state => state.purchaseRequests,
    getPrFilter: state => state.filter,
    isPendingRedDot: state => state.purchaseRequests.some(pr => pr.status === "DRAFT"),
  },
};

export default modulePurchaseRequest;
